<template>
  <layout :drawerShow="false" :drawer="false">
    <template slot="nav-tools" v-if="currentUser.roles.some(r => r.id === 1)">
      <smart-btn class="mr-2" @click.native="openDialogNewRelease()">
        <v-icon>mdi-text</v-icon>
        <span class="pl-1 d-none d-sm-flex">Ajouter</span>
      </smart-btn>
    </template>
    <template slot="content">
      <div class="d-flex flex-column justify-center align-center my-4" style="gap:16px">
        <p class="mb-0 text-h5">{{ releaseNotes.length === 0 ? 'Aucune mise à jour' : 'Mises à jour :' }} </p>
        <v-card class="py-6 px-4 d-flex flex-column" v-for="(release,iRelease) in releaseNotes" :key="iRelease" style="gap:16px; max-width: 600px; width: 600px">
          <div class="d-flex flex-column" style="gap:4px" v-for="(item,i) in release" :key="i">
            <div v-if="i > 0" style="height: 1px;width: 100%" class="grey lighten-1 mb-4"></div>
            <div class="d-flex align-center justify-space-between" style="gap: 4px">
              <div class="d-flex align-center" style="gap: 4px">
                <site-label v-for="site in item.sites" :sitename="site"></site-label>
              </div>
              <div v-if="currentUser.roles.some(r => r.id === 1)" class="d-flex align-center" style="gap: 4px">
                <v-icon class="red--text" size="medium" style="cursor: pointer" @click="openDialogDeleteRelease(item.id)">mdi-delete</v-icon>
              </div>
            </div>
            <p class="mb-0 text-subtitle-2 grey--text">{{ format(item.publish_date,'d MMMM yyyy',{locale:fr}) }}</p>
            <div v-html="item.modifications" class="mb-0 mt-4 ml-2"></div>
            <div v-if="item.images !== null && item.images.length > 0" style="height: 1px;width: 50%" class="mx-auto my-2 grey lighten-2"></div>
            <div class="d-flex align-center" style="gap: 8px">
              <img @click="openDialogImage(image)" v-for="(image,iImage) in item.images" :key="iImage" :src="'/api/file/download/release/' + image" alt="image" style="object-fit: cover;width: 75px;height: 75px; cursor: pointer">
            </div>
          </div>
        </v-card>
      </div>
      <smart-dialog
          v-model="newRelease"
          title="Nouvelle release">
        <div class="d-flex flex-column pa-4" style="gap: 32px">
          <div v-for="(release,i) in searchform.releases" :key="i" class="d-flex flex-column" style="gap: 4px">
            <div v-if="i > 0" style="width: 100%;height: 1px;" class="grey mb-4"></div>
            <v-row>
              <v-col :cols="i > 0 ? '5' : '6'">
                <v-select
                    multiple
                    v-model="release.sites"
                    item-text="text"
                    item-value="value"
                    :error="release.sites.length === 0 && saveClicked"
                    label="Sites"
                    :items="sites"
                    :defaultSelectAll="false"
                />
              </v-col>
              <v-col :cols="i > 0 ? '5' : '6'">
                <smart-picker
                    v-model="release.publishDate"
                ></smart-picker>
              </v-col>
              <v-col cols="2" v-if="i > 0" class="d-flex justify-center">
                <v-icon class="red--text" style="cursor: pointer;padding: 0 8px" @click="deleteReleaseInForm(i)">mdi-delete</v-icon>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" class="d-flex flex-column" style="gap:4px">
                <p class="mb-0 text-subtitle-1 font-weight-bold">Modifications :</p>
                <smart-editor v-model="release.modifications" />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" class="d-flex flex-column" style="gap:4px">
                <p class="mb-0 text-subtitle-1 font-weight-bold">Images :</p>
                <div class="d-flex align-center" style="gap: 16px">
                  <img v-for="(image,i) in release.images" @click="openDialogImage(image)" :key="i" :src="'/api/file/download/release/' + image" alt="picture" style="object-fit: cover; width: 75px; height: 75px;cursor: pointer">
                  <smart-btn secondary @click.native="openDialogNewImage(i)">
                    <v-icon>mdi-plus</v-icon>
                  </smart-btn>
                </div>
              </v-col>
            </v-row>
          </div>
          <div>
            <smart-btn @click.native="addNewRelease()">
              <v-icon>mdi-plus</v-icon>
              <span class="pl-1 d-none d-sm-flex">Nouvelle release</span>
            </smart-btn>
          </div>
          <div v-if="!checkForm && saveClicked" class="d-flex align-center pa-4 red lighten-5 red--text" style="gap: 32px; border-radius: 8px">
            <v-icon class="red--text">mdi-alert</v-icon>
            <p class="mb-0" style="font-weight: 700">Veuillez remplir tous les champs</p>
          </div>
        </div>
        <template #actions>
          <div class="d-flex justify-end">
            <smart-btn :disabled="!checkForm" class="mr-2" @click.native="saveReleases()">
              <v-icon>mdi-content-save</v-icon>
              <span class="pl-1 d-none d-sm-flex">Enregistrer</span>
            </smart-btn>
          </div>
        </template>
      </smart-dialog>
      <smart-dialog
        v-model="deleteReleaseDialog"
        title="Supression d'une release"
      >
        <p class="mb-0 pa-4 text-xl-subtitle-1">Voulez vous supprimer cette release ?</p>
        <template #actions>
          <div class="d-flex justify-end">
            <smart-btn class="red" @click.native="deleteRelease()">
              Supprimer
            </smart-btn>
          </div>
        </template>
      </smart-dialog>
      <smart-dialog
          v-model="newImageDialog"
          title="Ajouter une nouvelle image"
      >
        <document-uploader
            @uploaded="imageUploaded"
            url="/api/file/upload/releasenote"
            acceptedFiles=".jpg,.jpeg"
        />
      </smart-dialog>
      <smart-dialog
        v-model="openImageDialog"
        :width="1000"
        :persistent="false"
      >
        <img style="height: auto;width: 100%" :src="imageToShow" alt="image">
      </smart-dialog>
    </template>
  </layout>
</template>
<script>
import Layout from "@/views/Layout";
import {get, post} from "@/utils/api";
import SiteLabel from "@/components/commons/SiteLabel.vue";
import SmartEditor from "@/components/commons/SmartEditor.vue";
import SmartMultiSelect from "@/components/commons/SmartMultiSelect.vue";
import {format, parse} from "date-fns";
import {fr} from "date-fns/locale";
import DocumentUploader from "@/components/commons/DocumentUploader.vue";

export default {
  name: "ReleaseNotes",
  components: {
    DocumentUploader,
    SmartMultiSelect,
    SmartEditor,
    SiteLabel,
    Layout
  },
  data() {
    return {
      releaseNotes: [],
      sites:[
        {
          text:"Hotelissima",
          value:"Hotelissima"
        },
        {
          text:"Zil Maurice",
          value:"ZilMaurice"
        },
        {
          text:"Zil Caraibes",
          value:"ZilCaraibes"
        },
        {
          text:"Hotel & Lagons",
          value:"HLagons"
        },
        {
          text:"Smartresas",
          value:"Smartresas"
        },
        {
          text:"Smartprice",
          value:"Smartprice"
        }
      ],
      newRelease:false,
      deleteReleaseDialog:false,
      newImageDialog:false,
      openImageDialog:false,
      searchform:{
        releases:[
          {
            sites:[],
            publishDate:format(new Date(),'dd/MM/yyyy'),
            modifications:null,
            images:[]
          }
        ]
      },
      releaseIdToDelete:null,
      releaseIndexAddImage:null,
      imageToShow:null,
      saveClicked:false
    }
  },
  created() {
    this.getReleases()
  },
  watch: {},
  computed: {
    fr() {
      return fr
    },
    checkForm(){
      return this.searchform.releases.length > 0 &&
          this.searchform.releases.every(release =>
              release.sites.length > 0 &&
              release.publishDate &&
              release.modifications && release.modifications.trim() !== ""
          )
    }
  },
  methods:{
    format,
    openDialogNewRelease(){
      this.saveClicked = false
      this.newRelease = true;
    },
    addNewRelease(){
      this.saveClicked = false
      this.searchform.releases.push({
        sites:[],
        publishDate:format(new Date(),'dd/MM/yyyy'),
        modifications:null,
        images:[]
      })
    },
    async saveReleases(){
      this.saveClicked = true
      const url = "/api/releasenote/create"
      if (this.checkForm){
        this.saveClicked = false
        await post(url, this.searchform.releases).res(() => {
          this.getReleases()
          this.newRelease = false;
          this.searchform.releases = [
            {
              sites:[],
              publishDate:format(new Date(),'dd/MM/yyyy'),
              modifications:"",
              images:[]
            }
          ]
        });
      }
    },
    deleteReleaseInForm(i){
      this.searchform.releases.splice(i,1)
    },
    getReleases(){
      get('/api/releasenote/list').json((res) => {
        const releaseGrouped = Object.values(
            res.map(r => {
              return {
                ...r,
                publish_date: parse(r.publish_date,'yyyy-MM-dd',new Date())
              }
            }).reduce((acc, curr) => {
              (acc[curr.publish_date] = acc[curr.publish_date] || []).push(curr)
              return acc
            }, {})
        )
        this.releaseNotes = releaseGrouped.sort((a, b) => {
          return b[0].publish_date - a[0].publish_date
        })
      })
    },
    deleteRelease(){
      const url = `/api/releasenote/delete/${this.releaseIdToDelete}`
      post(url).res(() => {
        this.getReleases()
        this.deleteReleaseDialog = false;
      });
    },
    openDialogDeleteRelease(id){
      this.releaseIdToDelete = id
      this.deleteReleaseDialog = true
    },
    openDialogNewImage(i){
      this.releaseIndexAddImage = i
      this.newImageDialog = true
    },
    imageUploaded(data){
      this.newImageDialog = false
      data.forEach(r => {
        this.searchform.releases[this.releaseIndexAddImage].images.push(r.name)
      })
    },
    openDialogImage(link){
      this.imageToShow = '/api/file/download/release/' + link
      this.openImageDialog = true
    }
  },
}
</script>
<style>
p {
  margin-bottom: 0 !important;
}
</style>
